import httpStatus from 'http-status'
import React, { useState, useEffect } from 'react'
import { Container, Card, Row, Col, Form, Button, Image, Spinner } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import { authenticationActions as authActions } from '../../../_actions/authentication.actions'
import { alertActions } from '../../../_actions/alert.actions'
import { usersService } from '../../../_services/users.service'
import PasswordChecklist from '../../Account/Users/_Components/PasswordChecklist'
import { clientActions } from '../../../_actions/client.actions'
import { userService } from '../../../_services/user.service'
import { userActions } from '../../../_actions/user.actions'
import { authenticationService as authService } from '../../../_services/authentication.service'

export default function AccountSetup({ history, match }) {
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [isValid, setIsValid] = useState(false)
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)

  const handleActivateAccount = () => {
    setSubmitting(true);

    let accessToken;
    
    usersService.setupAccount(match.params.token, password)
      .then(setupData => {        
        accessToken = setupData.accessToken;
        
        dispatch(authActions.setToken(setupData.accessToken))

        return authService.refresh(setupData.providerId, setupData.accessToken)
      })
      .then(clientData => {
        dispatch(clientActions.setAccount(clientData));

        return userService.me(accessToken);
      })
      .then(userData => {
        dispatch(userActions.setCurrentUser(userData));
        dispatch(authActions.setPermissions(userData.permissions));

        history.push('/dashboard', { welcome: true })
      })
      .catch(error => {
        setSubmitting(false)

        if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
          dispatch(alertActions.error(error.response.data.message))
        } else {
          dispatch(alertActions.error('Something went wrong. Please try again.'))
        }
      });
  }

  useEffect(() => {
    usersService.getSetupToken(match.params.token)
      .then(data => {
        setLoading(false)
        setData(data)
      })
      .catch(() => {
        history.push('/login')

        dispatch(alertActions.error('Your setup token was not found. Please contact the account holder.'))
      })
  }, [dispatch, history, match.params.token]);

  if (loading) {
    return <Spinner animation='border' />
  }

  return (
    <Container>
      <Row className='mt-4'>
        <Col xs='3'>
        { data.providerLogo &&
          <Row>
            <Col>
              <Image src={data.providerLogo}  fluid /> 
            </Col>
          </Row>
        } 
          <Row>
            <Col>
              <h5 className='font-weight-normal'>Hello, { data.firstName } { data.lastName }</h5>
            </Col>
          </Row>

          <Row>
            <Col>
              <p>{ data.providerName } is using AxS Health to improve patient communication. </p>
              <br />
              <p>With your AxS account, you'll be able to send patient forms, schedule telehealth appointments, and send patient messages.</p>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col className='lead'>Setup Account</Col>
          </Row>

          <Row className="mb-4">
            <Col className='lead my-1'>
              <small>Setup your AxS Health account by entering your new password.</small>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card className='axs-shadow axs-more-rounded border-0'>
                <Card.Body>
                  <Row className="mb-4">
                    <Col>
                      <Row>
                        <Col>Username</Col>
                      </Row>
                      <Row>
                        <Col className='text-muted'>{ data.username }</Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col xs='7'>
                      <Row>
                        <Col>
                          Password
                        </Col>
                      </Row>
                      <Row className='my-2'>
                        <Col>
                          <Form.Group controlId="formPassword">
                            <Form.Control 
                              type={showPassword ? 'text' : "password"} 
                              onChange={(e) => setPassword(e.target.value)}
                              className='font-weight-light'
                              placeholder="Enter Password" 
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Form.Check 
                            id="custom-password-switch"
                            type="switch"
                            label="Show Password"
                            onChange={() => setShowPassword(!showPassword)}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col className='text-muted'>
                      <Row>
                        <Col>
                          <small className='axs-font-weight-medium'>Your password must include:</small>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <PasswordChecklist password={password} setIsValid={(value) => setIsValid(value)}/>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs='7'>
                      <Button disabled={!isValid || submitting} onClick={handleActivateAccount} variant='success' block>{ submitting ? <i className="fa fa-spinner fa-spin fa-fw"></i> : 'Setup Account'}</Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}
